import { render, staticRenderFns } from "./SiteHeadline.vue?vue&type=template&id=4b1f6c7a&scoped=true"
import script from "./SiteHeadline.vue?vue&type=script&lang=js"
export * from "./SiteHeadline.vue?vue&type=script&lang=js"
import style0 from "./SiteHeadline.vue?vue&type=style&index=0&id=4b1f6c7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1f6c7a",
  null
  
)

export default component.exports